// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Icon } from '../components/Icon';
import type { Color, GlyphProps } from '../components/Icon/Icon.types';

const ViewTimelineIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 4H11.5C12.8807 4 14 5.11929 14 6.5C14 7.88071 12.8807 9 11.5 9H4.5C3.11929 9 2 7.88071 2 6.5C2 5.11929 3.11929 4 4.5 4ZM11.5 7C11.7761 7 12 6.77614 12 6.5C12 6.22386 11.7761 6 11.5 6H4.5C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7H11.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 10H13.5C14.8807 10 16 11.1193 16 12.5C16 13.8807 14.8807 15 13.5 15H6.5C5.11929 15 4 13.8807 4 12.5C4 11.1193 5.11929 10 6.5 10ZM13.5 13C13.7761 13 14 12.7761 14 12.5C14 12.2239 13.7761 12 13.5 12H6.5C6.22386 12 6 12.2239 6 12.5C6 12.7761 6.22386 13 6.5 13H13.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 16H11.5C10.1193 16 9 17.1193 9 18.5C9 19.8807 10.1193 21 11.5 21H18.5C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16ZM11.5 19C11.2239 19 11 18.7761 11 18.5C11 18.2239 11.2239 18 11.5 18H18.5C18.7761 18 19 18.2239 19 18.5C19 18.7761 18.7761 19 18.5 19H11.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 4H19.5C20.8807 4 22 5.11929 22 6.5C22 7.88071 20.8807 9 19.5 9H17.5C16.1193 9 15 7.88071 15 6.5C15 5.11929 16.1193 4 17.5 4ZM19.5 7C19.7761 7 20 6.77614 20 6.5C20 6.22386 19.7761 6 19.5 6H17.5C17.2239 6 17 6.22386 17 6.5C17 6.77614 17.2239 7 17.5 7H19.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ViewTimelineIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  const { value: isIconFlagEnabled } = useFeatureGate('trello_ads_icons');

  const LazyAdsIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "ADS-ViewTimelineIcon" */ '@atlaskit/icon/core/timeline'
      ),
    { namedImport: 'default', preload: false },
  );

  const adsIconSize = size === 'medium' || size === 'small' ? size : undefined;

  return isIconFlagEnabled ? (
    <span className={dangerous_className}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ghost',
          feature: 'ADS Icon',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <LazyAdsIcon
              label={label || ''}
              testId={testId || 'ViewTimelineIcon'}
              color={color as Color}
              size={adsIconSize}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </span>
  ) : (
    <Icon
      testId={testId || 'ViewTimelineIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={ViewTimelineIconGlyph}
    />
  );
};
